/**
 * Map a DRF error payload onto Formik field errors or a toast.
 *
 * @param {?Object<string, *>} data API error body.
 * @param {function(!Object<string, string>): void} setErrors Formik setErrors.
 * @param {function({type: string, message: string}): void} notify Toast helper.
 * @return {void}
 */
export const applyApiErrors = (data, setErrors, notify) => {
  const fieldErrors = {};
  const nonField = [];

  if (data && typeof data === "object") {
    Object.entries(data).forEach(([key, value]) => {
      if (key === "detail" || key === "non_field_errors") {
        nonField.push(
          typeof value === "string" ? value : Array.isArray(value) ? value.join(" ") : "",
        );
        return;
      }
      Array.isArray(value) ? (fieldErrors[key] = value.join(" ")) : nonField.push(value);
    });
  }

  if (Object.keys(fieldErrors).length) {
    setErrors(fieldErrors);
    return;
  }
  notify({
    type: "error",
    message: nonField.filter(Boolean).join(" ") || data?.detail || "Something went wrong",
  });
};
